@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/custom-cards-3x4/glass-house-brand-group-three-by-four-stack-content/glass-house-brand-group-three-by-four-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
.glass-house-3-x-4-card {
  box-sizing: border-box;
  display: grid;
  background: #9f9f9f;
  border: 1px solid #9f9f9f;
  gap: 1px;
  align-content: start;
}
.glass-house-3-x-4-card ::ng-deep * {
  background: white;
}
.glass-house-3-x-4-card {
  margin: 0.5rem;
  grid-template-rows: 6.25rem 2.125rem 4.5rem 1.25rem calc(8.75rem - 1px * 4);
}
.glass-house-3-x-4-card.has-label {
  grid-template-rows: 6.25rem 3.25rem 4.5rem 1.25rem calc(7.65rem - 1px * 4);
}
.glass-house-3-x-4-card * {
  box-sizing: border-box;
}
.glass-house-3-x-4-card ::ng-deep .glass-house-quantity-and-badges {
  gap: 0.25rem !important;
}
.glass-house-3-x-4-card ::ng-deep .glass-house-quantity {
  font-size: 0.875rem;
}
.glass-house-3-x-4-card ::ng-deep .glass-house-2-columns {
  padding: 4px 0 !important;
}
.glass-house-3-x-4-card ::ng-deep .glass-house-quantity-and-price {
  gap: 0 !important;
}
/*# sourceMappingURL=glass-house-brand-group-three-by-four-stack-content.component.css.map */
